import { CheckboxProps } from './types'

export function Checkbox({
  id,
  label,
  checked,
  hasError,
  onChange,
  inputRef
}: CheckboxProps) {
  return (
    <label className="flex items-start justify-start gap-2 text-left">
      <div className="relative flex size-4 items-center justify-center  pt-2">
        <input
          id={id}
          ref={inputRef}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className={`peer size-4 appearance-none rounded border bg-[#F9F5FF] transition-colors checked:bg-[#F9F5FF] focus:outline-none focus:ring-2 focus:ring-[var(--primary)]/50 ${
            hasError ? 'border-red-500' : 'border-[var(--primary)]'
          }`}
        />
        <svg
          className="pointer-events-none absolute size-3 text-[var(--primary)] opacity-0 peer-checked:opacity-100"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
      {label}
    </label>
  )
}
